/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Userdropdown_Upgrade1Inputs */

const zh_userdropdown_upgrade1 = /** @type {(inputs: Userdropdown_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级`)
};

const en_userdropdown_upgrade1 = /** @type {(inputs: Userdropdown_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const es_userdropdown_upgrade1 = /** @type {(inputs: Userdropdown_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {Userdropdown_Upgrade1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const userdropdown_upgrade1 = /** @type {((inputs?: Userdropdown_Upgrade1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Userdropdown_Upgrade1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_userdropdown_upgrade1(inputs)
	if (locale === "en") return en_userdropdown_upgrade1(inputs)
	return es_userdropdown_upgrade1(inputs)
});
export { userdropdown_upgrade1 as "userDropdown_upgrade" }